import React, { useEffect } from "react";
import { Switch, Route } from "react-router";
import PrerenderedLoadable from "components/prerenderLoadable";
import useLocalStorage from "hooks/useLocalStorage";
import { _SCORE_SETTINGS } from "common/constants/sportsConstants";
import useCommonStore from "hooks/useCommonStore";
import axios from "axios";
import Url from "../../common/constants/environment";
import useStore from "../../hooks/useStore";

const BetbleLiveComponent = PrerenderedLoadable(() => import("./betbleLive"));
const LiveStreamComponent = PrerenderedLoadable(() => import("./liveStream"));
const MajorComponent = PrerenderedLoadable(() => import("./major"));
const SoccerComponent = PrerenderedLoadable(() => import("./soccer"));
const BaseballComponent = PrerenderedLoadable(() => import("./baseball"));
const BasketballComponent = PrerenderedLoadable(() => import("./basketball"));
const VolleyballComponent = PrerenderedLoadable(() => import("./volleyball"));
const HockeyComponent = PrerenderedLoadable(() => import("./hockey"));
const FootballComponent = PrerenderedLoadable(() => import("./football"));
const LolComponent = PrerenderedLoadable(() => import("./lol"));
const StarcraftComponent = PrerenderedLoadable(() => import("./starcraft"));
const ProtoComponent = PrerenderedLoadable(() => import("./proto"));

const Score = ({ sportsType }) => {
  const { getItem, setItem } = useLocalStorage();
  const { setIsAdminIP } = useCommonStore();

  //  const { bannerStore } = useStore();

  //  useEffect(() => {
  //    bannerStore.getList();
  //  }, [bannerStore]);

  const checkAdminIp = (access_ip) => {
    for (let i of Url.admin_ip) {
      if (access_ip.includes(i)) setIsAdminIP(true);
    }
  };

  useEffect(() => {
    const scoreSettings = getItem("scoreSettings");

    if (!!scoreSettings) {
      window.scoreSettings = scoreSettings;
    } else {
      setItem("scoreSettings", JSON.stringify(_SCORE_SETTINGS));
    }

    axios.get("https://api64.ipify.org/?format=json").then((res) => {
      checkAdminIp(res.data.ip);
    });
  }, []);

  return (
    <Switch>
      {/*<Route path="/live" component={BetbleLiveComponent} />*/}
      <Route path="/live" component={LiveStreamComponent} />
      <Route path="/major" component={MajorComponent} />
      <Route path="/soccer" component={SoccerComponent} />
      <Route path="/baseball" component={BaseballComponent} />
      <Route path="/basketball" component={BasketballComponent} />
      <Route path="/volleyball" component={VolleyballComponent} />
      <Route path="/hockey" component={HockeyComponent} />
      <Route path="/football" component={FootballComponent} />
      <Route path="/lol" component={LolComponent} />
      <Route path="/starcraft" component={StarcraftComponent} />
      <Route path="/proto/win" component={ProtoComponent} />
    </Switch>
  );
};

export default Score;
